export default {
  standard: 'standard',
  pleaseEnterCodeOrName: 'please enter a code or name',
  code: 'code',
  classCode: 'class code',
  className: 'class name',
  pleaseSelect: 'please select',
  tableName: 'table name',
  identify: 'identify',
  classDetail: 'class detail',
  classType: 'class type',
  changeRecords: 'change records',
  changeType: 'change type',
  changeUser: 'change user',
  changeTime: 'change time',
  changeDetail: 'change detail',
  isPrimary: 'is primary',
  isNull: 'is null',
  standardAttribute: 'standard attribute',
  attributeCode: 'attribute code',
  attributeType: 'attribute type',
  referenceAttribute: 'reference attribute',
  length: 'length',
  decimalPoint: 'decimalPoint',
  defaultValue: 'default value',
  columnName: 'column name',
  unit: 'unit',
  ruleExpression: 'rule expression',
  enterRuleExpression:
    'class attribute surrounded by braces ( for example {{xxx}} ), will be replaced with equivalent attribute value, otherwise, it will be treated as string.',
  relationIdentify: 'relation identify',
  createAttribute: 'create attribute',
  attributeDetail: 'attribute detail',
  changeBefore: 'change before',
  changeAfter: 'change after',
  createClass: 'create class',
  attributeName: 'attribute name',
  editStatus: 'edit status',
  viewDetail: 'view detail',
  editClass: 'edit class',
  deleteClass: 'delete class',
  editAttribute: 'edit attribute',
  deleteAttribute: 'delete attribute',
  whtherPublishClass: 'whether publish the selected class',
  pleaseEnterCode: 'please enter the code',
  pleaseEnterMathesRule: 'please enter the code that mathes the rule',
  onlyEnterNumbersGreaterThanEqual0: 'only numbers greater than or equal to 0 can be entered',
  onlyEnterNumbersGreaterThanEqual1: 'only numbers greater than or equal to 1 can be entered',
  displayReferenceClassAttributeId: 'display reference class attribute',
  confirmDeleteClass: 'whether delete the class?',
  pleaseDeleteChildClass: 'please delte the child class firstly',
  infoType: 'infoType',
  pleaseEnterInfoType: 'please enter the infoType',
  viewStorageSet: 'view storage set',
  allowExport: 'allow export',
  allowImport: 'allow import',
  allowUpdate: 'allow update',
  fieldName: 'fieldName',
  pleaseSelectTheClassToPublish: 'please select the class to publish',
  tagAndDocumentCannotBePublishedSimultaneously:
    'tag and document class cannot be published simultaneously',
  publishSuccess: 'published successfully',
  tip: 'tip',
  yes: 'yes',
  no: 'no',
  syncPublishTheClassAndChildrenSuccessfully:
    'synchronized publish the class and children successfully',
  pleaseSelectTheClassToBeUnpublished: 'please select the class to be unpublished',
  unsubscribedClassSuccessfully: 'cancel publish the class successfully',
  syncCancelPublishTheClassAndChildrenSuccessfully:
    'synchronized cancel publish the class and children successfully',
  canCelPublish: 'cancel publish',
}
